<template>
    <div class="page-sidebar">
        <div class="page-sidebar-body" v-if="configuration.metadata.description">
            <idom :configuration="configuration" />
        </div>
        <resource v-if="configuration.contents.length" v-for="attachment of configuration.contents" :content="attachment" :key="attachment.id" />
    </div>
</template>

<script>
    export default {
        name: 'Sidebar',
        props: {
            configuration: Object
        },
        computed: {

        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .page-sidebar
    {
        margin-top: 90px;
        float: right;
        width: 400px;
        border-radius: 5px;
        border: 1px solid @e4;
        z-index: 10;
        clear: both;

        .resource-summary
        {
            padding: 30px;
            border-top: 1px solid @e4;
            border-bottom: 0;

            .resource-title
            {
                font-size: 18px;
                line-height: 22px;
            }

            .thumbnails
            {
                margin-top: 20px;

                .thumbnail
                {
                    width: 100px;
                    height: 100px;
                    box-shadow: 0 3px 10px -2px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1);
                }
            }

            &:first-child
            {
                border-top: 0;
            }
        }

        &::after
        {
            visibility: hidden;
            display: block;
            font-size: 0;
            content: " ";
            clear: both;
            height: 0;
        }
    }

    .page-sidebar-body
    {
        padding: 30px;

        .idom
        {
            h2
            {
                font-size: 18px;
                margin: 30px 0 10px;
                line-height: 22px;

                &:first-child
                {
                    margin-top: 0;
                }
            }

            p, ul, ol, li
            {
                font-size: 15px;
                line-height: 18px;
            }
        }
    }
</style>
